// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

//@actions
const updateClientContactTime = require('actions/contactCenter/updateClientContactTime/updateClientContactTime');
const profile = require('actions/profile');


// @components
const UpdateClientContactTime = require('components/contactCenter/updateClientContactTime/updateClientContactTime');

class UpdateClientContactTimeView extends React.Component {

    render() {
        return (
            <UpdateClientContactTime
                {...this.props}
            />
        );
    }

}

UpdateClientContactTimeView.propTypes = {
    immUpdateClientContactTime: PropTypes.object.isRequired,
    immProfileFields : PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    validateUIStep: PropTypes.func.isRequired,
    setVisibleStep :  PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    requestProfile : PropTypes.func.isRequired,
    onResetUpdateClientContactTimeData :  PropTypes.func.isRequired,
}

module.exports.constructor = UpdateClientContactTimeView;
module.exports.UpdateClientContactTimeView = connect(
    state => ({
        immUpdateClientContactTime: state.updateClientContactTime,
        immProfileFields: state.profile,
    }),
    {
        validateStep : updateClientContactTime.validateStep,
        validateUIStep: updateClientContactTime.validateUIStep,
        setVisibleStep : updateClientContactTime.setVisibleStep,
        handleFinish: updateClientContactTime.saveClientContactTime,
        onResetUpdateClientContactTimeData:  updateClientContactTime.onResetUpdateClientContactTimeData,
        requestProfile: profile.requestProfile,
        setFromTime: updateClientContactTime.setFromTime,
        setToTime: updateClientContactTime.setToTime
    }
)(UpdateClientContactTimeView);
